
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface PlaceholderTabProps {
  title: string;
  description: string;
}

const PlaceholderTab: React.FC<PlaceholderTabProps> = ({ title, description }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Card className="border border-gray-200">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="flex flex-col items-center justify-center py-12 px-4">
            <div className="rounded-full bg-blue-100 p-4">
              <div className="h-12 w-12 rounded-full bg-blue-200"></div>
            </div>
            <p className="mt-6 text-center text-gray-500">
              This feature is coming soon. We're working on it!
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlaceholderTab;
